import DatePicker from "react-datepicker";

import React, { useState } from "react";

const AppDatePicker = React.forwardRef(
  (
    {
      list,
      autoFocus,
      autoComplete,
      className,
      value,
      name,
      onClick,
      readOnly,
      onKeyDown,
      onKeyUp,
      onChange,
      borderColor,
    },
    ref
  ) => {
    // eslint-disable-next-line no-lone-blocks
    {
      const [dpOpen, setDpOpen] = useState(false);
      const openDatePicker = () => {
        setDpOpen(!dpOpen);
      };
      return (
        <React.Fragment>
          <input
            ref={ref}
            name={name}
            list={list}
            autoFocus={autoFocus}
            autoComplete={autoComplete}
            className={className}
            value={value}
            onClick={() => {
              onClick && onClick();
              openDatePicker();
            }}
            readOnly={readOnly}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            onChange={onChange}
          />
          <DatePicker
            name={name}
            onChange={(date, event) => {
              onChange({
                currentTarget: {
                  name,
                  value: new Date(date).toLocaleDateString("en-GB"),
                },
              });
              setDpOpen(false);
            }}
            open={dpOpen}
            onClickOutside={() => {
              setDpOpen(false);
            }}
            customInput={<div style={{ position: "absolute" }}></div>}
          />
        </React.Fragment>
      );
    }
  }
);

export default AppDatePicker;
